import {
  AdvancedFiltersLookupState,
  FeasibilityState,
  FlexibilityPricesState,
  InsightsChildState,
  InsightsState,
  ScoreState,
  SimilarSurveysState,
  SurveyCreationPricingState,
} from './survey-creation-insights-state.model';

export const INITIAL_SCORE_STATE: ScoreState = {
  scorePercentage: null,
  loading: false,
  error: null,
};

export const INITIAL_ADVANCED_FILTERS_LOOKUP_STATE: AdvancedFiltersLookupState =
  {
    matchedGroups: [],
    respondentCount: 0,
    error: null,
    criteriaSurveyOptions: [],
    groupSurveyOptions: [],
    psidRefsBySurveyId: {},
  };

export const INITIAL_FEASIBILITY_STATE: FeasibilityState = {
  total: 0,
  quotaGroups: [],
  audience: [],
  advancedFiltersLookup: { ...INITIAL_ADVANCED_FILTERS_LOOKUP_STATE },
  cpi: 0,
  suppliers: [],
  loading: false,
  error: null,
};

export const INITIAL_FLEXIBILITY_PRICES_STATE: FlexibilityPricesState = {
  prices: null,
  error: null,
};

export const INITIAL_SURVEY_CREATION_PRICING_STATE: SurveyCreationPricingState =
  {
    offerPrice: null,
    surveyPauseThreshold: null,
    blendApplied: false,
  };

export const INITIAL_SIMILAR_SURVEYS_STATE: SimilarSurveysState = {
  surveys: [],
  status: 'idle',
  error: null,
  isStale: false,
  searchedTargetingKey: null,
  searchedGlobally: false,
  globalSearchUsed: false,
};

export const DEFAULT_CHILD_INSIGHTS_STATE: InsightsChildState = {
  score: { ...INITIAL_SCORE_STATE },
  feasibility: { ...INITIAL_FEASIBILITY_STATE },
  flexibilityPrices: { ...INITIAL_FLEXIBILITY_PRICES_STATE },
  pricing: { ...INITIAL_SURVEY_CREATION_PRICING_STATE },
  similarSurveys: { ...INITIAL_SIMILAR_SURVEYS_STATE },
};

export const INITIAL_SURVEY_CREATION_INSIGHTS_STATE: InsightsState = {
  activeChildId: null,
  children: {},
};
